import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hotjar = defineConnector({
  identifier: "hotjar",
  name: "Hotjar",
  tagLine: "Heatmaps and behavior analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.hotjar\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Hotjar API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Hotjar, go to **Integrations > Hotjar API** and generate a new personal access token.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.hotjar.io/v1/users/me",
  },
});
